<template>
    <div>
        <v-autocomplete
                v-model=selectedSession
                :items="sessions"
                :loading="this.$apollo.queries.sessions.loading"
                color="white"
                :item-text="itemTitle"
                item-value="id"
                placeholder="Start typing to Search"
                label="Session"
                return-object
                @change="emitSelected"
        >


            <template v-slot:item="data">

                <template v-if="data.item">
                    <template v-if="data.item.trainingClass">

                        <v-list-item-avatar v-if="data.item.trainingClass.iconUrl" >
                            <img :src="data.item.trainingClass.iconUrl">
                        </v-list-item-avatar>
                        <v-list-item-avatar v-else color="grey"/>
                        <v-list-item-content>
                            <v-list-item-title>{{data.item.trainingClass.title}} (CL-{{data.item.trainingClass.id}})</v-list-item-title>
                            <v-list-item-subtitle>{{data.item.date | formatDate}} - {{data.item.trainingClass.company}}</v-list-item-subtitle>
                        </v-list-item-content>
                    </template>
                    <template v-else>
                        <v-list-item-avatar color="grey"/>
                        <v-list-item-content v-text="data.item.id"></v-list-item-content>
                    </template>

                </template>
            </template>

        </v-autocomplete>
    </div>
</template>

<script>
    import TRAINING_SESSIONS_ALL from "../../graphql/TrainingSessionsAll.gql"
    import moment from 'moment'

    export default {
        data() {
            return {
                selectedSession: this.session,
                currentSession: {},
            }
        },
        props: {
            future: {
                type: Boolean,
                default: true
            },
            session: {
                type: Object,
            }
        },
        watch: {
            session() {
                this.selectedSession = this.session
            },
        },
        apollo: {
            sessions: {
                query: TRAINING_SESSIONS_ALL,
                variables() {

                    let wheres = [];

                    if(this.future){
                        wheres.push({
                            column: "DATE",
                            operator: "GTE",
                            value: moment().set({hour: 0, minute: 0, second: 0, millisecond: 0})
                        })
                    }

                    if(wheres.length > 0){
                        return {
                            where: {
                                "AND": wheres
                            }
                        }
                    }

                    return {}
                },
                update: data => data.sessions

            },
        },
        methods: {
            itemTitle(item) {
                if (item.trainingClass) {
                    return item.trainingClass.title + ' @ ' + this.$options.filters.formatDate(item.date)
                }

                return 'SES-' + item.id + ' @ ' + this.$options.filters.formatDate(item.date)
            },

            emitSelected(item) {
                this.$emit('selected', item)
            }
        },
    }
</script>

<style scoped>

</style>